<crm-object-association-panel
  [id]="id()"
  [name]="name()"
  [objectType]="objectType()"
  [associatedObject]="'Company'"
  [customCardContent]="cardContent"
  [customHeaderContent]="headerContent"
  [createCardData]="cardFunction"
  [requiresPrimaryAssociation]="primaryAssociationRequired()"
></crm-object-association-panel>
<ng-template #headerContent let-card="card">
  @if (card.website) {
    <a class="website-link" [href]="card.website" target="_blank" rel="noopener">
      {{ card.website }}
    </a>
  }
</ng-template>

<ng-template #cardContent let-card="card">
  @if (card.address) {
    <crm-common-association-card-content [iconName]="'location_on'">
      {{ card.address }}
    </crm-common-association-card-content>
  }
  @if (card.phone) {
    <crm-common-association-card-content [iconName]="'phone'">
      <mat-card-subtitle>
        <a href="tel:{{ card.phone }}">
          {{ card.phone }}
        </a>
      </mat-card-subtitle>
    </crm-common-association-card-content>
  }
</ng-template>
